import React from "react";
import "./MoreButton.scss";
import * as img from "../../assets/images/index";

type Props = {
  count: number;
  total: number;
  onClick: any;
  isLoading: boolean;
};

const MoreButton: React.FC<Props> = ({ count, total, onClick, isLoading }) => {
  return (
    <button type="button" className="MoreButton" onClick={() => onClick()}>
      {!isLoading && (
        <div>
          <img src={img.moreArrow} alt="더보기 버튼" width="22" height="13" />
          <span>
            더보기 ({count}/{total})
          </span>{" "}
        </div>
      )}
      {isLoading && <img src={img.spinner} alt="loading" className="loading" />}
    </button>
  );
};

export default React.memo(MoreButton);
